Debug = {
    ShowCellId: function () {
        $(".booking-cell, .booking-cell-unav, .booking-item").each((i, el) => $(el).attr("title", $(el).data("cellid")))
    }
};